import { Trans } from "react-i18next";
import { t } from "i18next";
import { StudioSectionLabel } from "./StudioSectionLabel";
import { useVideoRemakeStudio } from "./VideoRemakeStudioContext";

/**
 * Studio 左侧参考视频预览栏。视频优先用 <video>，封面图作为兜底 poster。
 *
 * 设计稿节点：4913:30988（268x477 圆角 8 容器）。
 */
export const ReferenceVideoSidebar = () => {
  const { referenceVideo } = useVideoRemakeStudio();
  const videoUrl = referenceVideo?.videoUrl;
  const coverUrl = referenceVideo?.coverUrl;

  return (
    <aside className="flex h-full w-[316px] shrink-0 flex-col gap-[12px] border-l border-kds-border bg-kds-bg px-[24px] pt-[24px]">
      <StudioSectionLabel tooltip={t("The reference video used to guide style and structure.")}>
        <Trans>Reference Video</Trans>
      </StudioSectionLabel>
      <div className="flex w-[268px] flex-col items-center">
        <div
          className="h-[477px] w-full overflow-hidden rounded-[8px] bg-kds-bg-subtle"
          aria-label={t("Reference video preview")}
        >
          {videoUrl ? (
            <video
              src={videoUrl}
              poster={coverUrl}
              controls
              playsInline
              preload="metadata"
              className="h-full w-full object-cover"
            />
          ) : coverUrl ? (
            <img src={coverUrl} alt="" className="h-full w-full object-cover" />
          ) : null}
        </div>
      </div>
    </aside>
  );
};
